/** Catégorie utilisée avec type `article` — le backend ne connaît pas encore `tender`. */
export const TENDER_CATEGORY = "appel-offre";

export function isTenderContent(item: { type?: string; category?: string }): boolean {
  const cat = (item.category || "").toLowerCase().trim();
  if (item.type === "tender") return true;
  if (cat === TENDER_CATEGORY || cat === "appel-d-offres" || cat === "appels-offres") return true;
  if (cat.includes("appel") && cat.includes("offre")) return true;
  return false;
}
